import React, {useState} from 'react';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import {useDispatch} from "react-redux";
import {tableUnbanFromTable} from "../store/table/actions";

const TableBanned = ({user, me, table, token}) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const dispatch = useDispatch();

    const setMouseOver = () => {
        if (!isMouseOver) {
            setIsMouseOver(true);
        }
    }

    const setMouseAway = () => {
        if (isMouseOver) {
            setIsMouseOver(false);
        }
    }

    const handleDelete = () => {
        dispatch(tableUnbanFromTable(token, {
            tableId: table.dynamic.id,
            userId: user.userId,
            username: user.nickname
        }))
    }

    return (
        <div style={{
            background: isMouseOver && `url(${process.env.REACT_APP_BACKEND_URL}/image/background) no-repeat center`,
            color: isMouseOver && 'whitesmoke',
            width: '100%',
            borderRadius: 5,
            display: 'flex',
            boxShadow: (isMouseOver) && '0 0 10px 2px white',
            justifyContent: 'space-between',
            padding: '6px 16px',
            boxSizing: 'border-box'
        }}
             onMouseEnter={setMouseOver}
             onMouseLeave={setMouseAway}>
            <div>
                {
                    user.nickname
                }
            </div>
            {
                (isMouseOver && me.roleId < 3) && (<IconButton
                    className="text trash"
                    sx={{height: 20, width: 20, cursor: 'pointer'}}
                    aria-label="delete"
                    aria-describedby={user.id} type="button" onClick={handleDelete}>
                    <ClearIcon/>
                </IconButton>)
            }
        </div>
    );
};

export default TableBanned;